import React from "react";
import { Link, useLocation } from "react-router-dom";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Container,
  Col,
} from "react-bootstrap";
import LogoURL from "../../../assets/img/baolinPrivate/logo-baolin-header-removebg-preview.png"
import { useGuestContext } from "../../../contexts/GuestContext";


function AuthNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const location = useLocation();
  const { language, toggleLanguage } = useGuestContext();
  return (
    <>
      <div className="d-block">
        <Navbar
          className="position-absolute w-100 d-block"
          expand="lg"
          variant={collapseOpen ? "white" : "transparent"}
        >
          <Container>
            <div className="navbar-wrapper">
              <Navbar.Brand href="#pablo" onClick={(e) => e.preventDefault()}>
                <div className="d-none d-md-block">

                  <span > {language === "Chinese" ? "寶林禪寺法會報名" : "Bao Lin Event Registration"}</span>
                </div>
                <img src={LogoURL} alt="Company Logo" width="100" className="mr-4 d-md-none" />
              </Navbar.Brand>
            </div>
            {/* <button
              className="navbar-toggler navbar-toggler-right border-0"
              type="button"
              onClick={() => setCollapseOpen(!collapseOpen)}
            >
              <span className="navbar-toggler-bar burger-lines"></span>
              <span className="navbar-toggler-bar burger-lines"></span>
              <span className="navbar-toggler-bar burger-lines"></span>
            </button>
            <Navbar.Collapse className="justify-content-end" in={collapseOpen}>
              <Nav navbar>
                <Nav.Item className="mr-1">
                  <Nav.Link to="/auth/login" as={Link}>
                    <i className="nc-icon nc-single-02"></i>
                    Admin Login
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item
                  className={
                    location.pathname === "/login"
                      ? "active mr-1"
                      : "mr-1"
                  }
                >
                  <Nav.Link
                    to="/guest"
                    as={Link}
                    onClick={(e) => {
                      e.preventDefault(); // Prevents navigating to the link
                      toggleLanguage(); // Toggles the language
                    }}
                  >
                    <i className="nc-icon nc-chat-round"></i>
                    {language === "Chinese" ? "English" : "中文"}
                  </Nav.Link>

                </Nav.Item>
                <Nav.Item
                  className={
                    location.pathname === "/auth/lock-screen-page"
                      ? "active mr-1"
                      : "mr-1"
                  }
                >

                </Nav.Item>
              </Nav>
            </Navbar.Collapse> */}
          </Container>
        </Navbar>
      </div>

    </>
  );
}

export default AuthNavbar;
